import React, { useState } from "react";

const ToolNamePage = ({ onSubmit }) => {
  const [value, setValue]         = useState("");
  const [touched, setTouched]     = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const handleSubmit = () => {
    setTouched(true);
    if (value.trim()) onSubmit(value.trim());
  };

  const labelFloated = isFocused || value.length > 0;

  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "4px",
          overflow: "hidden",
          width: "420px",
          boxShadow: "0 4px 28px rgba(0,0,0,0.35)",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "#bb1ccc",
            color: "white",
            padding: "16px 20px",
            fontSize: "18px",
            fontWeight: "500",
          }}
        >
          Enter Your Tool Name
        </div>

        {/* Body */}
        <div style={{ padding: "28px 20px 20px" }}>
          <div style={{ position: "relative", marginBottom: "20px" }}>

            {/* Floating label */}
            <label
              style={{
                position: "absolute",
                top: labelFloated ? "-8px" : "14px",
                left: "12px",
                fontSize: labelFloated ? "11px" : "14px",
                color: touched && !value.trim() ? "#ef4444" : "#bb1ccc",
                background: "white",
                padding: "0 4px",
                transition: "all 0.15s",
                pointerEvents: "none",
              }}
            >
              Tool Name
            </label>

            <input
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onFocus={() => setIsFocused(true)}
              onBlur={() => { setIsFocused(false); setTouched(true); }}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
              style={{
                width: "100%",
                padding: "14px 12px",
                border: `2px solid ${touched && !value.trim() ? "#ef4444" : "#bb1ccc"}`,
                borderRadius: "4px",
                fontSize: "14px",
                outline: "none",
                boxSizing: "border-box",
              }}
            />

            {touched && !value.trim() && (
              <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#ef4444" }}>
                Tool name is required.
              </p>
            )}
          </div>

          <div style={{ textAlign: "right" }}>
            <button
              onClick={handleSubmit}
              style={{
                background: "#bb1ccc",
                color: "white",
                border: "none",
                borderRadius: "4px",
                padding: "10px 28px",
                fontWeight: "700",
                fontSize: "14px",
                cursor: "pointer",
                letterSpacing: "0.5px",
              }}
            >
              SUBMIT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolNamePage;